"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTrackingForExperiments = void 0;
const experiments_1 = require("./experiments");
/**
 * Builds Segment user traits from the in-memory experiment assignment:
 *   split-test-{name}: bucket
 *   split-test-encountered-{name}: 'on' | 'off'
 *   user-encountered-experiment: boolean
 */
const createTrackingForExperiments = () => {
    const assignments = (0, experiments_1.getExperimentAssignments)();
    const encountered = (0, experiments_1.getEncounteredExperiments)();
    const experiments = Object.fromEntries(Object.entries(assignments).map(([name, bucket]) => [`split-test-${name}`, bucket]));
    const encounteredExperiments = Object.fromEntries(Object.entries(encountered).map(([name, value]) => [
        `split-test-encountered-${name}`,
        value ? 'on' : 'off',
    ]));
    return {
        ...experiments,
        ...encounteredExperiments,
        'user-encountered-experiment': Object.values(encountered).some(Boolean),
    };
};
exports.createTrackingForExperiments = createTrackingForExperiments;
